import { RUHSAT_TIPI_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const ruhsatTipiSorgula = () => {
    return getRequest({ url: RUHSAT_TIPI_SORGULA });
}

export default ruhsatTipiSorgula;